import { hashString } from "@eldrun/shared";

/** Alfabeto de Crockford (sem I, L, O, U): seed exibida com 7 caracteres. */
const CROCKFORD = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const DECODE: Record<string, number> = Object.fromEntries([...CROCKFORD].map((c, i) => [c, i]));
Object.assign(DECODE, { I: 1, L: 1, O: 0 });

/** Codifica a seed (u32) como código Crockford base-32 de 7 caracteres, ex.: "3F8K2ZQ". */
export function formatSeed(seed: number): string {
  let value = seed >>> 0;
  let out = "";
  for (let i = 0; i < 7; i++) {
    out = (CROCKFORD[value % 32] as string) + out;
    value = Math.floor(value / 32);
  }
  return out;
}

function decodeCrockford(code: string): number | undefined {
  let value = 0;
  for (const char of code.toUpperCase()) {
    const digit = DECODE[char];
    if (digit === undefined) return undefined;
    value = value * 32 + digit;
  }
  return value <= 0xffffffff ? value : undefined;
}

/**
 * Converte o texto digitado no lobby em seed u32, na ordem:
 * 1. exatamente 7 caracteres alfanuméricos → código de Crockford (ida e volta com `formatSeed`,
 *    inclusive códigos só de dígitos, como "0000010" = 32);
 * 2. só dígitos (outro comprimento) e < 2^32 → o próprio número;
 * 3. qualquer outro texto → hash FNV-1a do texto normalizado (trim, NFC, minúsculas).
 */
export function parseSeed(text: string): number {
  const normalized = text.trim().normalize("NFC");
  if (/^[0-9A-Za-z]{7}$/.test(normalized)) {
    const decoded = decodeCrockford(normalized);
    if (decoded !== undefined) return decoded;
  }
  if (/^\d+$/.test(normalized)) {
    const value = Number(normalized);
    if (value <= 0xffffffff) return value;
  }
  return hashString(normalized.toLowerCase());
}
